import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const AfterSaleService = {
    list: async (filters) => axios.post(API_URL + "/after-sales-attendance/list", filters).then(({data}) => data).catch((err) => { throw err }),
    getById: async (id) => axios.get(API_URL + "/after-sales-attendance/" + id).then(({data}) => data).catch((err) => { throw err }),
    getAttendances: async () => axios.get(API_URL + "/after-sales/get/attendances").then(({data}) => data).catch((err) => { throw err }),
    create: async (model) => axios.post(API_URL + "/after-sales-attendance", model).then(({data}) => data).catch((err) => { throw err }),
    edit: async (model, id) => axios.post(API_URL + "/after-sales-attendance/" + id, model).then(({data}) => data).catch((err) => { throw err }),
    delete: async (id) => axios.delete(API_URL + "/after-sales-attendance/" + id).then(({data}) => data).catch((err) => { throw err }),
};

export default AfterSaleService;